import { useMutation } from "@tanstack/react-query"

import {
  createPublicIntakeFormInvitationSubmission,
  createPublicIntakeFormPublicationSubmission,
  requestPublicIntakeFormOtp,
  uploadPublicIntakeFormInvitationDocument,
  uploadPublicIntakeFormPublicationDocument,
  verifyPublicIntakeFormOtp,
} from "./api"

export function useRequestPublicIntakeFormOtp() {
  return useMutation({
    mutationFn: ({ token, recipientToken }: { token: string; recipientToken?: string }) =>
      requestPublicIntakeFormOtp(token, recipientToken),
    meta: { errorToast: false },
  })
}

export function useVerifyPublicIntakeFormOtp() {
  return useMutation({
    mutationFn: ({ token, otp, recipientToken }: { token: string; otp: string; recipientToken?: string }) =>
      verifyPublicIntakeFormOtp(token, otp, recipientToken),
    meta: { errorToast: false },
  })
}

// Upload and submission failures are reported to the respondent inside the form
// document by the shell bridge, so they must never surface as a global toast.
export function useUploadPublicIntakeFormPublicationDocument() {
  return useMutation({ mutationFn: uploadPublicIntakeFormPublicationDocument, meta: { errorToast: false } })
}

export function useCreatePublicIntakeFormPublicationSubmission() {
  return useMutation({ mutationFn: createPublicIntakeFormPublicationSubmission, meta: { errorToast: false } })
}

export function useUploadPublicIntakeFormInvitationDocument() {
  return useMutation({ mutationFn: uploadPublicIntakeFormInvitationDocument, meta: { errorToast: false } })
}

export function useCreatePublicIntakeFormInvitationSubmission() {
  return useMutation({ mutationFn: createPublicIntakeFormInvitationSubmission, meta: { errorToast: false } })
}
